import { InvoiceListReportTemplateData } from "./InvoiceListReportTemplateData";
import { backgroundLogo, headerLogo } from "../constants/PdfReports";
import { formatDate, formatTime } from "../core/Utility";

export const InvoiceListReportImportTemplate = (data: InvoiceListReportTemplateData) => {

    return {
        background: [
            {
                image: backgroundLogo,
                width: 580,
                alignment: 'center',
                absolutePosition: {x: 0, y: 200}
            }
        ],
        header: [],
        footer: [],
        content: [
            {
                image: headerLogo,
                alignment: 'center',
                margin:[0,5,0,0]
            },
            {
                text: `Lista profaktura`,
                style: 'title',
                margin:[0,20,0,5]
            },
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }],
                margin:[0,5,0,10]
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['12%','13%','8%','7%','23%','10%', '7%', '21%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '100%',
                                        text: `Broj profakture: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        width: '100%',
                                        text: `Datum: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Poslata: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Pravno lice: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Komitent: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Iznos: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Plaćeno: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Email: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }],
                margin:[0,5,0,10]
            },
            data.reportData?.map((item) => {
                return ({
                    width: '50%',
                    layout: 'noBorders',
                    table: {
                        widths: ['12%','13%','8%','7%','23%','10%', '7%', '21%'],
                        body: [
                            [
                                {
                                    columns: [
                                        {
                                            text: `${item.documentId}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${formatDate(new Date(item.createdAt))} ${formatTime(new Date(item.createdAt))}h`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.sentEmail ? 'da' : 'ne'}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.isCompany ? 'da' : 'ne'}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.clientName}`,
                                            style: 'textLeft',
                                            margin:[0,0,0,0]
                                        }
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.accommodationPrice}`,
                                            style: 'textLeft',
                                            margin:[0,0,0,0]
                                        }
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.paid ? 'da' : 'ne'}`,
                                            style: 'textLeft',
                                            margin:[0,0,0,0]
                                        }
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.email}`,
                                            style: 'textLeft',
                                            margin:[0,0,0,0]
                                        }
                                    ]
                                },
                                
                            ]
                        ]
                    }
                }
            )}),
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }],
                margin:[0,5,0,10]
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['12%','13%','8%','7%','23%','10%', '7%', '21%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '100%',
                                        text: ``,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        width: '100%',
                                        text: ``,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: ``,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: ``,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: ``,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Ukupno plaćeno: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: ``,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${data.allPaidInvoices ?? ''}`,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                        ]
                    ]
                }
            },
        ],
        styles: {
            title: {
                fontSize: '14',
                alignment: 'center',
                margin:[0,20,0,10],
                bold: true
            },
            textLeft: {
                fontSize: '10',
                alignment: 'left',
            },
            textRight: {
                fontSize: '10',
                alignment: 'right',
            }
        }
    }
}